import {
  formatActionTaken,
  formatPhoneNumber,
  formatNonAgentStatus,
  OBJECT_ID_REGEX,
  featureEnabled,
} from 'utils';
import { react2angular } from 'react2angular/index';
import SendFeedbackButton from './SendFeedbackButton';

import MobileNavDropdown from './MobileNavDropdown';
import { HOME_INSPECTION_TYPES } from '../constants';

angular
  .module('bb.appointments')
  .component('appointmentModal', {
    transclude: true,
    bindings: {},
    controller: AppointmentModalController,
    controllerAs: 'vm',
    template: require('./appointment_modal.html'),
  })
  .component(
    'mobileNavDropdown',
    react2angular(MobileNavDropdown, ['appointment', 'setTab', 'tab']),
  )
  .component(
    'sendFeedbackButton',
    react2angular(SendFeedbackButton, [
      'appointmentConfig',
      'appointment',
      'appointments',
      'buttonStyle',
    ]),
  );

AppointmentModalController.$inject = [
  'ModalService',
  'AppointmentConfigService',
  'AppointmentStatusService',
  'FeedbackService',
  'ToastService',
  'ErrorService',
  '$rootScope',
  '$route',
  '$location',
];
function AppointmentModalController(
  ModalService,
  AppointmentConfigService,
  AppointmentStatusService,
  FeedbackService,
  ToastService,
  ErrorService,
  $rootScope,
  $route,
  $location,
) {
  const vm = this;

  vm.homeInspectionTypes = HOME_INSPECTION_TYPES;
  vm.redHighlightTypes = [
    ...HOME_INSPECTION_TYPES,
    'Buyer Visit',
    'Home Inspection',
    'Appraisal',
    'Photographer',
    'Pest Control',
  ];
  vm.appointmentModal = ModalService.appointmentModal;
  vm.hasNonAgentNotificationFeature = featureEnabled(
    'nonAgentNotificationFeature',
  );

  // To format appt status string
  vm.getStatusName = AppointmentStatusService.getStatusName;

  vm.closeModal = async () => {
    // Also save feedback if currently in editing
    if (
      vm.appointmentModal.tab === 'feedback' &&
      vm.appointmentModal.isEditingFeedback
    ) {
      await vm.saveFeedback();
    }
    ModalService.closeAppointmentModal();
  };

  // Tab control
  vm.appointmentModal.tab = 'history';
  // eslint-disable-next-line no-return-assign
  vm.setTab = tab => (vm.appointmentModal.tab = tab) && $rootScope.$digest();

  vm.updateAppointment = ackType => {
    ModalService.closeAppointmentModal(true);
    if (vm.appointmentModal.onCovidAckSubmit) {
      vm.appointmentModal.onCovidAckSubmit(ackType);
    }
  };

  vm.formatNonAgentStatus = formatNonAgentStatus;

  vm.formatActionTaken = ({
    status,
    originalTime,
    actionTaken,
    isPending,
    nonAgentNotified,
    date,
    auditEntry,
  }) => {
    return formatActionTaken(
      {
        date,
        auditEntry,
        status,
        originalTime,
        actionTaken,
        isPending,
        nonAgentNotified,
      },
      vm.appointmentModal.appointment?.type,
      vm.appointmentModal.appointment?.coop,
      vm.appointmentModal.mustCallContacts,
      vm.appointmentModal.appointment?.history,
    );
  };

  vm.formatPhoneNumber = formatPhoneNumber;

  // Feedback control
  vm.editFeedback = () => {
    vm.feedback = angular.copy(vm.appointmentModal.feedback);
    vm.appointmentModal.isEditingFeedback = true;
  };

  vm.recordFeedback = () => {
    const openFeedbackModal =
      $rootScope.openFeedbackModal || vm.appointmentModal.openFeedbackModal;
    openFeedbackModal({
      modalType: 'listing',
      modalMode: 'record',
      listingId: vm.appointmentModal.listing.id,
      appointmentId: vm.appointmentModal.appointment.id,
      onSubmit: () => {
        vm.saving = true;
        FeedbackService.getFeedback(
          vm.appointmentModal.appointment.id,
          vm.appointmentModal.listing.id,
        )
          .then(function (feedback) {
            vm.appointmentModal.feedback = feedback;
          })
          .finally(function () {
            vm.saving = false;
            if (vm.appointmentModal.onFeedbackModalSubmit) {
              vm.appointmentModal.onFeedbackModalSubmit();
            }
            ModalService.closeAppointmentModal(true);
          });
      },
    });
  };

  vm.cancelEditingFeedback = () => {
    vm.feedback = null;
    vm.appointmentModal.isEditingFeedback = false;
  };

  vm.saveFeedback = () => {
    const listingId = vm.appointmentModal.listing.id;
    vm.saving = true;
    FeedbackService.saveFeedback(
      vm.feedback.appointment,
      listingId,
      vm.feedback,
    )
      .then(function (updatedFeedback) {
        vm.appointmentModal.feedback = updatedFeedback;
        vm.feedback = null;
        vm.appointmentModal.isEditingFeedback = false;
      })
      .finally(function () {
        vm.saving = false;
      });
  };

  vm.onResponseChange = function (index, response) {
    vm.feedback.template[index] = { ...vm.feedback.template[index], response };
    setTimeout(() => $rootScope.$digest(), 0);
  };

  // All the logic for whether the Record Feedback button should be shown
  vm.shouldShowRecordFeedback = () => {
    const { appointment, serverDate, tab, feedback } = vm.appointmentModal;
    return (
      tab === 'feedback' &&
      !vm.appointmentModal.isEditingFeedback &&
      !(feedback && feedback.template) &&
      !(
        appointment &&
        (serverDate <= appointment.timeEnd ||
          [
            'Appraisal',
            'Home Inspection',
            'Photographer',
            'Pest Control',
          ].includes(appointment.type) ||
          appointment.status !== 'confirm')
      )
    );
  };

  // All the logic for whether the Send Reminder button should be shown
  vm.shouldShowSendReminder = () => {
    const { appointment, serverDate, tab } = vm.appointmentModal;
    return (
      appointment &&
      serverDate >= appointment.timeEnd &&
      appointment.status === 'confirm' &&
      !appointment.feedbackCollected &&
      ![
        'Appraisal',
        'Home Inspection',
        'Photographer',
        'Pest Control',
      ].includes(appointment.type) &&
      tab === 'feedback' &&
      !vm.appointmentModal.isEditingFeedback
    );
  };

  vm.sendReminder = () => {
    // Don't try to send more reminders if one is already sending
    if (vm.sendingReminder) return;

    const { listing, appointment } = vm.appointmentModal;
    vm.sendingReminder = true;
    FeedbackService.sendFeedbackReminder(listing.id, appointment.id)
      .then(function () {
        ToastService.add({
          message: 'Email sent!',
          type: 'success',
        });
      })
      .catch(function (err) {
        ErrorService.toastyHTTPErr(err);
      })
      .finally(function () {
        vm.sendingReminder = false;
      });
  };

  vm.shouldDisplayActionButtons = () => {
    const { listing } = vm.appointmentModal;
    const { auth } = $rootScope;
    if (!listing) return false;
    const allReps = [
      ...listing.reps.map(({ id }) => id),
      ...listing.hiddenReps.map(({ id }) => id),
    ];
    const isTeamAdmin =
      auth.team &&
      auth.role === 'TEAM_ADMIN' &&
      listing.reps.some(
        rep =>
          rep.team?.toString() === auth.team?.toString() ||
          auth.teams?.includes(rep.team),
      );
    return allReps.includes($rootScope.auth.id) || isTeamAdmin;
  };

  vm.showActionButton = buttonStatus => {
    const {
      permission,
      appointment: { id, listingContactTimeChange, status },
    } = vm.appointmentModal;
    if (
      (buttonStatus === 'confirm' || buttonStatus === 'deny') &&
      listingContactTimeChange &&
      status === 'time_change'
    ) {
      return false;
    }
    return permission[id] && permission[id][buttonStatus];
  };

  vm.openAppointmentActionModal = action => {
    const { appointment, onAppointmentActionModalConfirm } =
      vm.appointmentModal;

    // If the Angular DefaultController has been initialized (ie. user has visited an angular page),
    // $rootScope will contain openAppointmentActionModal(). Otherwise, fall back to the injected
    // function in vm.appointmentModal provided in React pages.
    const openAppointmentActionModal =
      $rootScope.openAppointmentActionModal ||
      vm.appointmentModal.openAppointmentActionModal;

    openAppointmentActionModal({
      agent: 'listing',
      action,
      appointment,
      onConfirm: onAppointmentActionModalConfirm || $route.reload,
    });
    vm.closeModal();
  };

  vm.getSuggestParams = () =>
    $location
      .path()
      // eslint-disable-next-line no-useless-escape
      .match(new RegExp(`\/listing\/${OBJECT_ID_REGEX}\/showings`, 'i')) // match with the Listing Showing Calendar page url
      ? '?redirectTo=listingCalendar'
      : '?redirectTo=calendar';

  vm.hasListingContacts = () =>
    vm.appointmentModal.appointmentConfig.contacts.some(({ type }) => {
      return ['Seller', 'Tenant', 'Landlord/Manager'].includes(type);
    });
}
